import { Box, Card, Divider, Grid } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { AiOutlineUser } from 'react-icons/ai';
import { HiOutlineBriefcase } from 'react-icons/hi';
import { MdDateRange } from 'react-icons/md';
import { RiPulseLine } from 'react-icons/ri';
import { ActivityLogSearchRequest, IJobSuggestions } from 'wisestep-api';
import {
  WsButton,
  WsDatePicker,
  WsSelect,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import JobTitleFilterNew from '../../../../../../components/filters/components/JobTitleFilterNew';
import RecruiterSuggestions from '../../../../../../components/filters/components/RecruiterSuggestions';
import { activityOptions } from '../utils/helper';

import FilterNameAndIcon from './componets/FilterNameAndIcon';

interface AdavancFiltersProps {
  onApply: (data: ActivityLogSearchRequest) => void;
  defaultFilters?: ActivityLogSearchRequest;
  onReset: () => void;
}
interface ActivityLogForm extends ActivityLogSearchRequest {
  jobs: IJobSuggestions[];
}
const AdavanceFilters = ({ defaultFilters, onApply, onReset }: AdavancFiltersProps) => {
  const methods = useForm<ActivityLogForm>({
    defaultValues: { ...defaultFilters, jobs: [] },
  });

  const [resetFlag, setResetFlag] = useState<boolean>(false);
  const onSubmit = (data: ActivityLogForm) => {
    setResetFlag(false);
    const { jobs, ...searchPayload } = data;
    searchPayload.jobIds = jobs.map((job) => job.id);
    onApply(searchPayload);
  };

  const onResetButton = () => {
    methods.reset();
    setResetFlag(true);
    onReset();
  };

  return (
    <FormProvider {...methods}>
      <Card
        component={'form'}
        sx={{ borderRadius: 2 }}
        onSubmit={methods.handleSubmit(onSubmit)}
        onReset={onResetButton}
      >
        <Box p={2}>
          <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK} bold>
            Advanced Filters
          </WsTypography>
        </Box>
        <Divider />
        <FilterNameAndIcon title="Job Title" icon={<HiOutlineBriefcase size={21} />}>
          <JobTitleFilterNew
            name="jobs"
            placeholder="Job Title's"
            defaultValue={methods.watch('jobs')}
            freeSolo={true}
            multiple={true}
            reset={resetFlag}
          />
        </FilterNameAndIcon>
        <FilterNameAndIcon title="Activity Type" icon={<RiPulseLine size={21} />}>
          <WsSelect name="activityType" selectArray={activityOptions} placeholder="Select" />
        </FilterNameAndIcon>
        <FilterNameAndIcon title="Recruiter" icon={<AiOutlineUser size={21} />}>
          <RecruiterSuggestions
            name="recruiters"
            multiple={true}
            requireRecruiter={false}
            value={methods.watch('recruiters')}
          />
        </FilterNameAndIcon>
        <FilterNameAndIcon title="Date Range" icon={<MdDateRange size={21} />}>
          <Box display="flex" gap={1} flexDirection="column">
            <WsDatePicker name="fromDate" label="From Date" disableFuture={true} />
            <WsDatePicker
              name="toDate"
              label="To Date"
              minDate={methods.watch('fromDate')}
              disableFuture={true}
              disablePast={true}
            />
          </Box>
        </FilterNameAndIcon>
        <Grid container gap={1} display="flex" justifyContent="flex-end" p={2}>
          <WsButton size="large" variant="outlined" type="reset">
            Reset
          </WsButton>
          <WsButton size="large" variant="contained" type="submit">
            Apply
          </WsButton>
        </Grid>
      </Card>
    </FormProvider>
  );
};
export default AdavanceFilters;
